import { Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { UpgradeLock } from '../DownloadModal/OptionTitle';

type ShareWithOthersProps = {
  onUpgrade: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
};

export const ShareWithOthers = ({ onUpgrade }: ShareWithOthersProps) => {
  const { t } = useTranslation('common_navbar');

  const shareWithOthersTestId = 'share-with-others';
  const shareWithOthersUpgradeLockTestId = 'share-with-others-upgrade-lock';

  return (
    <Flex flexDir='column' gap='2' data-testid={shareWithOthersTestId}>
      <Flex
        flexDir='row'
        justifyContent='space-between'
        alignItems='center'
        ml='2'
        mb='4'
        color='font.500'
        data-testid={shareWithOthersUpgradeLockTestId}
      >
        <UpgradeLock
          handleClickUpgrade={onUpgrade}
          upgradeText={t('modals.download.upgrade-premium')}
          postText={t('modals.share-panel.share-with-others.post-text')}
        />
      </Flex>
    </Flex>
  );
};
